/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubscriptionStatus {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
    ACTIVE_CANCELED = 'ACTIVE_CANCELED',
}
